import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import i18n from "../i18n";
import useIsMobile from "../hooks/useIsMobile";

const savedLanguage = localStorage.getItem("i18nextLng");
if (savedLanguage) {
  i18n.changeLanguage(savedLanguage);
  document.documentElement.lang = savedLanguage;
}

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isMobile = useIsMobile();
  const currentLang = i18n.language || "ar";

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang).then(() => {
      localStorage.setItem("i18nextLng", newLang);
      document.documentElement.lang = newLang;
      window.location.reload();
    });
  };

  return (
    <FormControl
      variant="standard"
      size="small"
      sx={{
        // minWidth: 45,
        width: isMobile ? "69px" : "auto",
        "& .MuiInput-underline:before": {
          borderBottomColor: "rgba(0, 0, 0, 0.42)",
          borderBottom: 0,
        },
      }}
    >
      <InputLabel id="language-select-label"></InputLabel>
      <Select
        labelId="language-select-label"
        value={currentLang}
        onChange={handleChange}
        sx={{
          fontSize: isMobile?"1rem": "1.1rem",
        }}
      >
        <MenuItem value="he">עברית</MenuItem>
        <MenuItem value="ar">العربية</MenuItem>
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher;
